// extracted by mini-css-extract-plugin
export default {"EsloganMaster":"eslogan_EsloganMaster__LkFCN","EsloganBox":"eslogan_EsloganBox__6LQ6b","EsloganTexto":"eslogan_EsloganTexto__vA3d9"};